<template>
    <div v-wechat-title="title" style="position: relative;">
        <div v-show="current_surgery == '1'" style="text-align: left; margin-left: 20px; color: red">说明：仅适用于当前单据</div>
        <el-button v-show="current_surgery != '1' && (activeName == 'first' || activeName == 'second')" type="primary" size="mini" style="position: absolute;top: 0;right: 20px;z-index: 1;" @click="openTmpfrom()">特殊年龄</el-button>
        <el-button v-show="createPermission && current_surgery != '1' && (activeName == 'first' || activeName == 'second')" type="primary" size="mini" style=" position: absolute;top: 0;right: 100px;z-index: 1;" @click="openaddfrom()">创建</el-button>
        <!-- <CloseButton type="close" msg="closeWindow" title="参数设置"></CloseButton> -->
        <el-tabs v-model="activeName" style="margin: 0px 20px 20px 20px">
            <el-tab-pane label="监护仪参数" name="first">
                <crud-facecade
                    ref="param-list1"
                    :url="url"
                    :columns="columnsList"
                    :addButton="{ enabled: false }"
                    :deleteButton="{ enabled: false }"
                    :updateButton="{ enabled: false }"
                    :fuzzySearch="false"
                    :tableHeight="tableHeight"
                >
                </crud-facecade>
            </el-tab-pane>
            <el-tab-pane label="麻醉机参数" name="second">
                <crud-facecade
                    ref="param-list2"
                    :url="url1"
                    :columns="columnsList"
                    :addButton="{ enabled: false }"
                    :deleteButton="{ enabled: false }"
                    :updateButton="{ enabled: false }"
                    :fuzzySearch="false"
                    :tableHeight="tableHeight"
                ></crud-facecade>
            </el-tab-pane>
            <el-tab-pane label="显示参数" name="third" v-if="current_surgery != '1'">
                <crud-facecade
                    :url="url2"
                    :columns="psysioParamColumnList"
                    :addButton="{ enabled: false }"
                    :deleteButton="{ enabled: false }"
                    :updateButton="{ enabled: false }"
                    :fuzzySearch="false"
                    :tableHeight="tableHeight"
                ></crud-facecade>
            </el-tab-pane>
        </el-tabs>
        <form-dialog :title="addfrom.title" :data="addfrom.data" :visible.sync="addfrom.dialogFormVisible" :columns="addColumnsList" @confirm="saveParam"></form-dialog>

        <form-dialog ref="tmp" width="80%" @extrabutton-click="ExtraButtonClick" :title="tmpfrom.title" :data="tmpfrom.data"  :visible.sync="tmpfrom.dialogFormVisible" :columns="tmpColumnsList" @confirm="saveTmpParam"></form-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `ParamSettings`,
    props: {},
    data() {
        return {
            title: `参数设置`,
            token: this.$route.query.token,
            surgeryId: this.$route.query.surgery_id,
            record_type: this.$route.query.record_type,
            current_surgery: this.$route.query.current_surgery,
            createPermission: false,
            activeName: `first`,
            addfrom: {
                dialogFormVisible: false,
                title: `新增参数`,
                data: {}
            },
            tmpfrom: {
                dialogFormVisible: false,
                title: `特殊年龄体征维护`,
                data: {}
            },
            mainData1: [],
            mainData2: [],
            url: {
                baseUrl: ``,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        let req = that.myaxios.get(`/api/AcisSystem/PhysioParam/Get?surgeryId=${this.surgeryId}&current_surgery=${this.current_surgery}&record_type=${this.record_type}`)
                        req.then(data => {
                            that.mainData1 = _.filter(data, { enum_physio_param_category: 1 }) || []
                            resolve(that.mainData1)
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                },
                putMany: row => {
                    let data = []
                    row.forEach(element => {
                        _.forIn(element, function(value, key) {
                            if (value === undefined || value === ``) {
                                element[key] = -999
                            }
                        })
                        data.push(element)
                    })
                    return new Promise((resolve, reject) => {
                        console.log(`rrrrrrrrrrrrrrrrrrrrrrrrrrrrr`, data)

                        let req = this.myaxios.put(`/api/AcisSystem/PhysioParam/PutMany?surgeryId=${this.surgeryId}&current_surgery=${this.current_surgery}&record_type=${this.record_type}`, data)
                        req.then(data => {
                            resolve(data)
                            this.sendMessage()
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                }
            },
            url1: {
                baseUrl: `/api/AcisSystem/PhysioParam`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        let req = that.myaxios.get(`/api/AcisSystem/PhysioParam/Get?surgeryId=${this.surgeryId}&current_surgery=${this.current_surgery}&record_type=${this.record_type}`)
                        req.then(data => {
                            that.mainData2 = _.filter(data, { enum_physio_param_category: 2 }) || []
                            resolve(that.mainData2)
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                },
                putMany: row => {
                    let data = []
                    row.forEach(element => {
                        _.forIn(element, function(value, key) {
                            if (value === undefined || value === ``) {
                                element[key] = -999
                            }
                        })
                        data.push(element)
                    })
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.put(`/api/AcisSystem/PhysioParam/PutMany?surgeryId=${this.surgeryId}&current_surgery=${this.current_surgery}&record_type=${this.record_type}`, data)
                        req.then(data => {
                            resolve(data)
                            this.sendMessage()
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                }
            },
            url2: {
                baseUrl: `/api/AcisSystem/RecordStyle`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        let req = that.myaxios.get(`/api/AcisSystem/RecordStyle/GetByPatient`, { recordType: this.$route.query.record_type, SurgeryInfoId: this.surgeryId })
                        req.then(data => {
                            resolve(data)
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                },
                putMany: row => {
                    row.forEach(element => {
                        let req = this.myaxios.put(
                            `/api/AcisSystem/RecordStyle/PutPatientInternal?Internal=${element.internal_minutes}&record_type=${this.$route.query.record_type}&SurgeryInfoId=${this.surgeryId}`
                        )
                        req.then(data => {
                            this.sendMessage()
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.put(`/api/AcisSystem/RecordStyle/PutMany`, row)
                        req.then(data => {
                            resolve(data)
                            this.sendMessage()
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                }
            },
            agegroups: []
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        console.log(this.surgeryId)
        this.loadPermissions()
    },
    computed: {
        ...mapGetters([`menu_icons`, `img_icons`, `screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 150) || 0
        },
        columnsList() {
            return [
                {
                    type: `string`,
                    label: `序号`,
                    prop: `id`,
                    isKey: true
                },
                {
                    type: `string`,
                    label: `项目`,
                    prop: `name`,
                    isListable: true,
                    isCreatable: true
                },
                {
                    type: `string`,
                    label: `网关`,
                    prop: `gwmapping_name`,
                    isListable: true,
                    readonly: function(that, { row }) {
                        return row.is_system
                    }
                },
                {
                    type: `imgicon`,
                    label: `图片`,
                    prop: `img_name`,
                    isListable: true,
                    readonly: false,
                    isCreatable: true,
                    options: this.img_icons
                },
                {
                    type: `colorpicker`,
                    label: `颜色`,
                    prop: `img_color`,
                    isCreatable: true,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `colorpicker`,
                    label: `预警颜色`,
                    prop: `warn_color`,
                    isCreatable: true,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `bool`,
                    label: `曲线显示`,
                    prop: `is_display_graph`,
                    isCreatable: true,
                    isListable: true,
                    options: `enum_bool`,
                    readonly: false
                },
                {
                    type: `bool`,
                    label: `数字显示`,
                    prop: `is_display_table`,
                    isCreatable: true,
                    isListable: true,
                    options: `enum_bool`,
                    readonly: false
                },
                {
                    type: `bool`,
                    label: `小数显示`,
                    prop: `is_decimal`,
                    isListable: true,
                    isCreatable: true,
                    options: `enum_bool`,
                    readonly: false
                },
                {
                    type: `float`,
                    label: `上限`,
                    prop: `upper_limit`,
                    isListable: true,
                    isCreatable: true,
                    readonly: false
                },
                {
                    type: `float`,
                    label: `下限`,
                    prop: `lower_limit`,
                    isCreatable: true,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `float`,
                    label: `预警上限`,
                    prop: `upper_warn`,
                    isListable: true,
                    isCreatable: true,
                    // default:1,
                    readonly: false
                },
                {
                    type: `float`,
                    label: `预警下限`,
                    prop: `lower_warn`,
                    isCreatable: true,
                    isListable: true,
                    // default:1,
                    readonly: false
                },
                {
                    type: `float`,
                    label: `偏移时间(秒)`,
                    prop: `offset_time`,
                    isCreatable: true,
                    isListable: true,
                    readonly: false
                }
                // {
                //     type: `buttongroup`,
                //     prop: `oper`,
                //     label: `操作`,
                //     width: `80`,
                //     isListable: true,
                //     readonly: false,
                //     options: function(that, { row }) {
                //         if (!row.is_system) {
                //             return [
                //                 {
                //                     class: `is-plain`,
                //                     label: `删除`,
                //                     icon: ``,
                //                     type: `danger`,
                //                     emit: `DeleteData`,
                //                     permission: `default`
                //                 }
                //             ]
                //         } else {
                //             return []
                //         }
                //     }
                // }
            ]
        },
        psysioParamColumnList() {
            return [
                {
                    type: `string`,
                    label: `序号`,
                    prop: `id`,
                    isKey: true
                },
                {
                    type: `select`,
                    label: `间隔`,
                    prop: `internal_minutes`,
                    isListable: true,
                    readonly: false,
                    config: {
                        clearable: false
                    },
                    options: [
                        { value: `1`, label: `1` },
                        { value: `2`, label: `2` },
                        { value: `3`, label: `3` },
                        { value: `4`, label: `4` },
                        { value: `5`, label: `5` },
                        { value: `10`, label: `10` },
                        { value: `15`, label: `15` },
                        { value: `20`, label: `20` },
                        { value: `25`, label: `25` },
                        { value: `30`, label: `30` },
                        { value: `60`, label: `60` }
                    ]
                },
                {
                    type: `colorpicker`,
                    label: `前景色`,
                    prop: `color`,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `colorpicker`,
                    label: `数据色`,
                    prop: `data_color`,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `colorpicker`,
                    label: `外框色`,
                    prop: `outline_color`,
                    isListable: true,
                    options: `enum_bool`,
                    readonly: false
                },
                {
                    type: `colorpicker`,
                    label: `曲线区网格色`,
                    prop: `graph_grid_color`,
                    isListable: true,
                    options: `enum_bool`,
                    readonly: false
                },
                {
                    type: `colorpicker`,
                    label: `时间坐标色`,
                    prop: `time_axis_color`,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `colorpicker`,
                    label: `值坐标色`,
                    prop: `value_axis_color`,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `colorpicker`,
                    label: `鼠标移入颜色`,
                    prop: `hover_color`,
                    isListable: true,
                    readonly: false
                },
                {
                    type: `colorpicker`,
                    label: `鼠标选中颜色`,
                    prop: `focus_color`,
                    isListable: true,
                    default: 1,
                    readonly: false
                }
            ]
        },
        addColumnsList() {
            return [
                {
                    type: `string`,
                    label: `项目`,
                    prop: `name`,
                    colspan: 12,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    label: `别名`,
                    prop: `alias`,
                    colspan: 12
                },
                {
                    type: `string`,
                    label: `网关映射名称`,
                    prop: `gwmapping_name`,
                    colspan: 12
                },
                {
                    type: `string`,
                    label: `单位`,
                    prop: `unit`,
                    colspan: 12
                },
                {
                    type: `imgicon`,
                    label: `图片`,
                    prop: `img_name`,
                    options: this.img_icons,
                    colspan: 12,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `colorpicker`,
                    label: `颜色`,
                    prop: `img_color`,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `colorpicker`,
                    label: `预警颜色`,
                    prop: `warn_color`,
                    colspan: 6
                },
                {
                    type: `bool`,
                    label: `曲线显示`,
                    prop: `is_display_graph`,
                    options: `enum_bool`,
                    colspan: 6,
                    default: 0
                },
                {
                    type: `bool`,
                    label: `数字显示`,
                    prop: `is_display_table`,
                    options: `enum_bool`,
                    colspan: 6,
                    default: 0
                },
                {
                    type: `bool`,
                    label: `小数显示`,
                    prop: `is_decimal`,
                    options: `enum_bool`,
                    colspan: 6,
                    default: 0
                },
                {
                    type: `float`,
                    label: `上限`,
                    prop: `upper_limit`,
                    colspan: 12
                },
                {
                    type: `float`,
                    label: `下限`,
                    prop: `lower_limit`,
                    colspan: 12
                },
                {
                    type: `float`,
                    label: `预警上限`,
                    prop: `upper_warn`,
                    colspan: 12
                },
                {
                    type: `float`,
                    label: `预警下限`,
                    prop: `lower_warn`,
                    colspan: 12
                },
                {
                    type: `float`,
                    label: `偏移时间(秒)`,
                    prop: `offset_time`,
                    colspan: 12,
                    default: 0,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                }
            ]
        },
        tmpColumnsList() {
            let me = this
            return [
                {
                    type: `select`,
                    label: `分类`,
                    prop: `group_name`,
                    colspan: 6,
                    config: {
                        allowCreate: true
                    },
                    options: this.agegroups,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    change: (that, { row }) => {
                        if (row.group_name) {
                            let r = _.find(me.agegroups, x => x.value == row.group_name)
                            this.$set(row, `min_age`, r && r.min_age)
                            this.$set(row, `max_age`, r && r.max_age)
                            this.$set(row, `oldid`, r ? 1 : 0)
                            let mainData = me.activeName == `first` ? me.mainData1 : (me.activeName == `second` ? me.mainData2 : [])
                            console.log(`mainData`, mainData)
                            row.details = mainData && mainData.map(t => {
                                let tmprow = r && r.group_details && _.find(r.group_details, x => x.dic_physio_param_id == t.id)
                                return {
                                    id: tmprow && tmprow.id || 0,
                                    dic_physio_param_id: tmprow && tmprow.dic_physio_param_id || t.id,
                                    name: t.name,
                                    upper_limit: tmprow && tmprow.upper_limit || t.upper_limit,
                                    lower_limit: tmprow && tmprow.lower_limit || t.lower_limit,
                                    upper_warn: tmprow && tmprow.upper_warn || t.upper_warn,
                                    lower_warn: tmprow && tmprow.lower_warn || t.lower_warn,
                                    enum_physio_param_category: t.enum_physio_param_category,
                                    enum_record_type: t.enum_record_type
                                }
                            }) || []
                        } else {
                            this.$set(row, `min_age`, ``)
                            this.$set(row, `max_age`, ``)
                            row.details = []
                        }
                    }
                },
                {
                    type: `integer`,
                    label: `最小年龄`,
                    prop: `min_age`,
                    colspan: 6,
                    readonly: function(that, { row, area }) {
                        return (row.enum_charge_status && row.enum_charge_status != 0) || me.chargeItemAddConfig == `0`
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `integer`,
                    label: `最大年龄`,
                    prop: `max_age`,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: ``,
                    colspan: 6,
                    readonly: false,
                    options: function(that, { row, area }) {
                        if (row.oldid > 0) {
                            return [
                                {
                                    label: `删除`,
                                    type: `danger`,
                                    emit: `deleteTmp`,
                                    permission: `default`
                                }
                            ]
                        }
                        return []
                    }
                },
                {
                    type: `table2`,
                    prop: `details`,
                    label: `详情`,
                    isListable: false,
                    isEditable: true,
                    isCreatable: true,
                    options: this.detailColumns,
                    colspan: 24,
                    config: {
                        height: this.screenHeight - 300
                    }
                }
            ]
        },
        detailColumns() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`
            },
            {
                type: `string`,
                label: `项目`,
                prop: `name`,
                isListable: true,
                readonly: true
            },
            {
                type: `float`,
                label: `上限`,
                prop: `upper_limit`,
                isListable: true,
                readonly: false
            },
            {
                type: `float`,
                label: `下限`,
                prop: `lower_limit`,
                isListable: true,
                readonly: false
            },
            {
                type: `float`,
                label: `预警上限`,
                prop: `upper_warn`,
                isListable: true,
                readonly: false
            },
            {
                type: `float`,
                label: `预警下限`,
                prop: `lower_warn`,
                isListable: true,
                readonly: false
            }
            ]
        }
    },
    methods: {
        loadagegroups() {
            let that = this
            let category = that.activeName == `first` ? 1 : (that.activeName == `second` ? 2 : -1)
            let req = this.myaxios.get(`/api/Operation/PhysioParamByAge/GetAgeGroup?record_type=${this.record_type}&enum_physio_param_category=${category}`) // 获取年龄分组
            req.then(data => {
                this.agegroups = data && data.map(t => {
                    return {
                        label: t.group_name,
                        value: t.group_name,
                        min_age: t.min_age,
                        max_age: t.max_age,
                        group_details: t.group_details
                    }
                }) || []
            }).catch(e => {
                console.log(e)
            })
        },
        ExtraButtonClick(target) {
            this[target.emit](target)
        },
        deleteTmp(row) {
            console.log(`row`, row)
            let info = row && row.formdata
            let that = this
            this.$confirm(`此操作将永久删除该分组, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            }).then(() => {
                if (!(info && info.group_name)) {
                    return
                }
                let category = that.activeName == `first` ? 1 : (that.activeName == `second` ? 2 : -1)
                let req = this.myaxios.delete(`/api/Operation/PhysioParamByAge/Delete?group_name=${info.group_name}&&record_type=${that.record_type}&enum_physio_param_category=${category}`)
                req.then(data => {
                    that.loadagegroups()
                    that.$refs[`tmp`].$refs[`form`].clearField()
                    that.$message.success(`删除成功`)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        openTmpfrom() {
            let that = this
            that.loadagegroups()
            that.tmpfrom.dialogFormVisible = true
        },
        saveTmpParam(data) {
            console.log(`save`, data)
            let that = this
            let details = data && data.details.map(t => {
                return {
                    ...t,
                    group_name: data.group_name,
                    min_age: parseInt(data.min_age),
                    max_age: parseInt(data.max_age)
                }
            })
            let req = this.myaxios.post(`/api/Operation/PhysioParamByAge/SaveMany`, details)
            req.then(res => {
                that.loadagegroups()
                that.$refs[`tmp`].$refs[`form`].clearField()
                that.$message.success(`保存成功`)
            }).catch(e => console.log(e))
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.createPermission = data && data.findIndex(item => item.permission === `surgery_list:AddPhysioParam`) != -1
            }).catch(e => {
                console.log(e)
            })
        },
        openaddfrom() {
            let that = this
            that.addfrom.dialogFormVisible = true
        },
        saveParam(data) {
            let that = this
            return new Promise((resolve, reject) => {
                let obj = { ...data, enum_Physio_param_category: that.activeName == `first` ? 1 : 2, enum_record_type: 0, is_system: 0 }
                console.log(obj)
                let req = this.myaxios.post(`/api/AcisSystem/PhysioParam/Post`, obj)
                req.then(res => {
                    that.addfrom.dialogFormVisible = false
                    that.reload()
                    resolve(res)
                }).catch(e => reject(e))
            })
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: {},
                    action: `ok`
                }
                winformMsg.acceptMessage(cefJson)
            }
        },
        reload() {
            this.$nextTick(function() {
                this.$refs[`param-list1`] && this.$refs[`param-list1`].ReloadListData()
                this.$refs[`param-list2`] && this.$refs[`param-list2`].ReloadListData()
            })
        }
    },
    watch: {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/ParamSettings.vue